import React, { useState } from 'react';
import { Box } from '@mui/material';
import { styled } from '@mui/material/styles';
import { getResponsiveSize } from '../../utils/responsive';

const brands = [
  'amazon.png',
  'spineClinic.png',
  'myntra.png',
  'nook.png',
  'mahindra.png',
  'iskcon.png',
  'makeMyTrip.png',
  'britannia.png',
];

const imageBaseUrl = process.env.REACT_APP_IMAGE_BASE_URL;
const CarouselContainer = styled(Box)(({ theme }) => ({
  overflow: 'hidden',
  whiteSpace: 'nowrap',
  padding: theme.spacing(2),
  position: 'relative',
  '&:hover .slider-container': {
    animationPlayState: 'paused',
  },
}));

const SliderContainer = styled(Box, {
  shouldForwardProp: (prop) => prop !== 'isPaused',
})(({ isPaused }) => ({
  display: 'inline-block',
  animation: 'slide 20s linear infinite',
  '@keyframes slide': {
    from: {
      transform: 'translateX(0)',
    },
    to: {
      transform: 'translateX(-50%)',
    },
  },
  animationPlayState: isPaused ? 'paused' : 'running',
  className: 'slider-container',
}));

const BrandImage = styled('img')(({ theme }) => ({
  width: 'auto',
  height: getResponsiveSize(50),
  display: 'inline-block',
  margin: theme.spacing(2, 4),
  transition: 'transform 0.3s ease',
  position: 'relative',
  backgroundSize: 'cover',
  zIndex: 1,
  '&:hover': {
    transform: 'scale(1.1)',
    zIndex: 2, // Ensure hovered image stays on top
  },
}));

const Brand = () => {
  const [isPaused, setPaused] = useState(false);

  const handleMouseEnter = () => setPaused(true);
  const handleMouseLeave = () => setPaused(false);

  return (
    <CarouselContainer
      onMouseEnter={handleMouseEnter}
      onMouseLeave={handleMouseLeave}
    >
      <SliderContainer isPaused={isPaused}>
        {brands.map((brand, index) => (
          <BrandImage key={index}  src={`${imageBaseUrl}${brand}`} alt={`Brand ${index + 1}`} />
        ))}
      </SliderContainer>
      <SliderContainer isPaused={isPaused}>
        {brands.map((brand, index) => (
          <BrandImage
            key={index + brands.length}
            // src={brand}
            src={`${imageBaseUrl}${brand}`}
            alt={`Brand ${index + 1}`}
          />
        ))}
      </SliderContainer>
    </CarouselContainer>
  );
};

export default Brand;
